export default "__VITE_ASSET__BphkfGUD__"